var _circle, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBbDefaultProfileImage(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31,
    fill: "#E1E1E1",
    stroke: "#BBBBBB",
    strokeDasharray: "4 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9375 23.875H22.0625C21.6138 23.875 21.25 24.2388 21.25 24.6875V39.3125C21.25 39.7612 21.6138 40.125 22.0625 40.125H39.9375C40.3862 40.125 40.75 39.7612 40.75 39.3125V24.6875C40.75 24.2388 40.3862 23.875 39.9375 23.875Z",
    stroke: "#565556",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 36.0619L26.363 30.9489C26.4384 30.8735 26.528 30.8136 26.6266 30.7728C26.7251 30.732 26.8308 30.7109 26.9375 30.7109C27.0442 30.7109 27.1498 30.732 27.2484 30.7728C27.347 30.8136 27.4366 30.8735 27.512 30.9489L32.0505 35.4874C32.1259 35.5628 32.2155 35.6227 32.3141 35.6635C32.4126 35.7043 32.5183 35.7253 32.625 35.7253C32.7317 35.7253 32.8373 35.7043 32.9359 35.6635C33.0345 35.6227 33.1241 35.5628 33.1995 35.4874L35.3005 33.3864C35.3759 33.311 35.4655 33.2511 35.5641 33.2103C35.6626 33.1695 35.7683 33.1484 35.875 33.1484C35.9817 33.1484 36.0873 33.1695 36.1859 33.2103C36.2845 33.2511 36.3741 33.311 36.4495 33.3864L40.75 37.6869",
    stroke: "#565556",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8438 30.375C34.5168 30.375 35.0625 29.8293 35.0625 29.1562C35.0625 28.4832 34.5168 27.9375 33.8438 27.9375C33.1707 27.9375 32.625 28.4832 32.625 29.1562C32.625 29.8293 33.1707 30.375 33.8438 30.375Z",
    fill: "#565556"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbDefaultProfileImage);
export default __webpack_public_path__ + "static/media/bb_default_profile_image.62d1d3ec31678557fe20d1de62b822c8.svg";
export { ForwardRef as ReactComponent };